import { Route, Switch } from 'react-router-dom';

import { PrivacyPolicy } from '../pages/PrivacyPolicy';

// Rota PÚBLICA (sem login): URL de política de privacidade exigida pelas
// lojas Apple e Google para os apps Driver e Operation.
export const PrivacyRoute = () => (
  <Switch>
    <Route path="/privacidade" exact component={PrivacyPolicy} />
  </Switch>
);
